<template>
  <div>
    <UserLoginController
      v-if="isIdentityFirstFlow"
      :context="context"
      :mfaType="mfaType"
      :redirectTo="completeRedirectUrl"
      :step="step"
      v-bind="$props"
    />
    <ContextLogin
      v-else
      :redirectTo="redirectTo"
      :context="context"
      headerText="Log in to your application using JumpCloud"
      submitButtonText="SSO Login"
      :clientType="clientType"
      :completeRedirectUrl="completeRedirectUrl"
    />
  </div>
</template>

<script>
import { UserRoutes } from 'client/routes/RouteGenerator';
import { useFeatureFlags } from 'client/stores/FeatureFlag';
import ContextLogin from 'client/containers/Login/ContextLogin.vue';
import UserLoginController from 'client/containers/user/UserLoginController.vue';

export default {
  name: 'SsoLoginWrapper',

  props: {
    clientType: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      default: '',
    },
    redirectTo: {
      type: String,
      default: '',
    },
  },
  components: {
    ContextLogin,
    UserLoginController,
  },

  /*
  * Code to display UserLoginController for Identity First
  * @todo Remove this code and ContextLogin component
  * in template once the feature flag goes to production
  */
  setup() {
    const { isIdentityFirstFlow } = useFeatureFlags();
    return { isIdentityFirstFlow };
  },

  data() {
    return {
      completeRedirectUrl: UserRoutes.ssoRedirectUrl(this.redirectTo),
    };
  },

  computed: {
    context() {
      return this.$route.query.context;
    },

    mfaType() {
      return this.$route.query.mfaType;
    },

    step() {
      return this.$route.query.step;
    },
  },
};
</script>
